import React, { useState, useEffect, useCallback } from "react";
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext'
import VideoBg from '~/components/video/bg'
import useAnalytics from '~/utils/analytics'
import { imgSize, notBlank } from '~/utils/helpers'

import * as styles from "~/styles/tiles/tile.module.scss"

const TilePk = ({ product, tile_ind, isInView, parStyles='', forceSingle=false }) => {
  const { isMobile } = useTheme()
  const { elev_select, ga_tile_click } = useAnalytics()
  
  const { media, link, pkstory } = product
  const [tileImage, setTileImage] = useState(false);
  const [options, setOptions] = useState(false);

  const is_pkstory = pkstory || false
  const is_showtwo = !forceSingle && (pkstory && pkstory.show_two)
  const align = !is_pkstory ? '' : product.pkstory.align ? styles['align_' + product.pkstory.align] : styles['align_left']

  const handleSelect = () => {
    ga_tile_click(product, tile_ind)
    elev_select(product, tile_ind)
  }

  const pick_image = useCallback(() => {
    let tile_image = {}

    if ( is_pkstory && is_showtwo && media ) {
      tile_image = isMobile ? media[0] : media[1]
      if (!tile_image) tile_image = media[0]
    } else if ( media ) {
      tile_image = media[0]
    }

    if ( tile_image.type === 'IMAGE') {
      tile_image = imgSize(tile_image.src,700)
    }

    if ( tile_image.hasOwnProperty('image')) {
      tile_image = imgSize(tile_image.image,700)
    }

    if ( tile_image.type === 'VIDEO') {
      setOptions({
        autoplay: true,
        controls: false,
        children: ['mediaLoader', 'posterImage'],
        setPlaysinline: true,
        playsinline: true,
        muted: true,
        loop: true,
        sources: tile_image.sources.filter(x => x.mimeType !== 'application/x-mpegURL').map((x) => {
          return {src: x.url, type: x.mimeType}
        })
      })
    } else {
      setOptions(false)
    }

    if ( tile_image ) {
      setTileImage(tile_image)
    }
  }, [isMobile, is_pkstory, media, is_showtwo])

  useEffect(() => {
    pick_image()
  }, [isMobile, pick_image]);

  const content = (
    <div className={`${styles.images} ${parStyles}`}>
      <>
        {is_pkstory && (
          <div className={`${styles.pkstory_content} ${align}`} style={{color: product.pkstory.color || '#fff'}}>
            {product.pkstory.title && (
              <div className={styles.title} dangerouslySetInnerHTML={{ __html: product.pkstory.title }} />
            )}
            {product.pkstory.copy && (
              <div className={styles.copy} dangerouslySetInnerHTML={{ __html: product.pkstory.copy }} />
            )}
            {product.pkstory.cta && (
              <div className={styles.cta} dangerouslySetInnerHTML={{ __html: product.pkstory.cta }} />
            )}
          </div>
        )}
        {tileImage && (
          <>
            {options ? (
              <VideoBg 
                options={options}
                vidclasses={`pkvid`}
                off={false}
                />
            ) : (
              <img src={tileImage} alt="" />
            )}
          </>
        )}
      </>
    </div>
  )

  return (
    <>
      {((is_pkstory && notBlank(pkstory.cta_link)) || link) ? (
        <Flink 
          href={(is_pkstory && notBlank(pkstory.cta_link)) ? pkstory.cta_link : link} 
          onClick={(e)=> handleSelect()}
        >
          {content}
        </Flink>
      ) : (
        <>
          {content}
        </>
      )}

      <div className={styles.infos} tile-infos="">
      </div>
    </>
  )
}

export default TilePk



// <div 
//   class="product_info-tile"
//   id="p<%= id %>" 
//   data-id="<%= id %>"
//   data-handle="<%= handle %>"
//   data-url="/products/<%= handle %>"
//   data-pl-id="<%= pl_pima %>" 
// >
//   <div class="images">
//     <% if ( link ) { %>
//       <a class="img_grid tile_link" href="<%= link %>" aria-label="<%= title %>">
//     <% } else { %>
//       <div class="img_grid">
//     <% }%>
//     <% if ( mediaType == 'IMAGE' ) { %>
//       <img 
//         src="<% if ( obj.hasOwnProperty('src') ) { %><%= src %><% } %>" 
//         class="image" 
//         alt="" 
//         loading="lazy" 
//         decode="async"
//         width="400" 
//         height="532" 
//       />
//     <% } else if ( mediaType == 'VIDEO' ) { %>
//       <div class="grid_img gallvid data-hj-suppress" data-vid-num="pk" data-hj-suppress>
//         <img 
//           src="<%= src %>" 
//           class="product_info-img" 
//           loading="lazy" 
//           width="400" 
//           height="532"
//           alt="" 
//         />
//       </div>
//     <% } %>
//     <% if ( link ) { %>
//       </a>
//     <% } else { %>
//       </div>
//     <% }%>

//   </div>

//   <div class="infos"></div>
// </div>
